import { render, staticRenderFns } from "./ColumnContents.vue?vue&type=template&id=401a3b52&scoped=true&"
import script from "./ColumnContents.vue?vue&type=script&lang=js&"
export * from "./ColumnContents.vue?vue&type=script&lang=js&"
import style0 from "./ColumnContents.vue?vue&type=style&index=0&id=401a3b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401a3b52",
  null
  
)

export default component.exports